import { message, Modal } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/other/Loader";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import { authLoginCallback } from "../../redux/action/authAction";
import {
  pipSaveProfile,
  pipGetLoginRole,
  pipSetAccessToken,
  capitalizeFirstLetter,
} from "../../utils/pip";
const AuthCheck = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [role, setRole] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isLoading } = useSelector((state) => state?.authReducer);

  useEffect(() => {
    const role = JSON.parse(localStorage.getItem("google_login_role"));
    const data = window.location?.search;

    handleAuthCallback(role, data);
  }, []);

  const handleCloseModel = () => {
    localStorage.removeItem("teacher_userData");
    localStorage.removeItem("users_data_rc01");
    localStorage.removeItem("rc01-token");
    localStorage.removeItem("google_login_role");
    setIsModalOpen(false);
    navigate(pageRoutes?.login);
  };

  const handleAuthCallback = (role, codeData) => {
    const callback = (response) => {
      console.log({ response });
      if (response.success) {
        const actualRole = pipGetLoginRole().startsWith("teacher")
          ? "teacher"
          : pipGetLoginRole();
        const loginRole = actualRole;
        setRole(response?.user?.google_classroom_role ?? "");
        if (loginRole == "student") {
          if (loginRole == response?.user?.google_classroom_role) {
            response?.user?.google_token &&
              pipSetAccessToken(response?.user?.google_token);
            response?.user && pipSaveProfile(response?.user);

            localStorage.removeItem("google_login_role");
            message.success("Login successful");
            navigate(pageRoutes?.home);
          } else {
            response?.user &&
              localStorage.setItem(
                "teacher_userData",
                JSON.stringify(response?.user)
              );
            setIsModalOpen(true);
          }
        } else if (loginRole == "teacher") {
          if (response?.user?.google_classroom_role == loginRole) {
            localStorage.removeItem("google_login_role");

            console.log({ifCondition:response})
            response?.user &&
              localStorage.setItem(
                "teacher_userData",
                JSON.stringify(response?.user)
              );

            message.success("Login successful");
            setTimeout(() => {
              if (
                response?.user?.redirected_from == "monthly" ||
                response?.user?.redirected_from == "yearly"
              ) {
                window.location.href =
                  "https://robotcombat101.com/teacher/subscriptions";
              } else {
                window.location.href = pageRoutes?.teacherPanelRedirection;
              }
            }, 1000);
          } else {
            response?.user?.google_token &&
              pipSetAccessToken(response?.user?.google_token);
                 console.log({elseCondition:response})
            response?.user && pipSaveProfile(response?.user);
            setIsModalOpen(true);
          }
        }
      }
    };
    dispatch(
      authLoginCallback({
        payload: codeData,
        role,
        callback,
      })
    );
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Modal
        title={``}
        open={isModalOpen}
        centered={true}
        onCancel={handleCloseModel}
        footer={null}
      >
        <div className="mt-4">
          <div className="modal-body border-0 pt-0">
            <div className="text-center mb-3">
              <img
                src="img/warning.png"
                alt=""
                className="mx-auto"
                style={{ maxWidth: "80px" }}
              />
            </div>
            <h4 className="ct_fs_28 ct_fw_600 text-center mb-4">Warning</h4>
            <p className="text-center mb-4 ct_fs_18">
              {`You are currently logged in as a ${role}, but you have selected the ${
                role === "teacher" ? "student" : "teacher"
              } role. Please confirm if you want to proceed with the ${role} role or cancel to make changes.`}
            </p>
          </div>

          <div className="d-flex align-items-center gap-4 flex-wrap justify-content-center ct_flex_column_575 ">
            <button
              type="button"
              onClick={() => {
                message.success("Login successful");
                role != "teacher"
                  ? navigate(pageRoutes?.home)
                  : (window.location.href =
                      pageRoutes?.teacherPanelRedirection);
              }}
              className="ct_custom_btn1 w-50"
            >
              Continue as {capitalizeFirstLetter(role)}
            </button>
            <button
              type="button"
              onClick={handleCloseModel}
              className="ct_custom_btn1 ct_outline_btn_12 w-50"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AuthCheck;
